import { FC } from 'react';
import { Col, Row } from 'reactstrap';
import getFieldComponent, { IFormProps } from '.';
import { PageViewModel } from '../Models';
import BaseViewModel from '../Models/BaseViewModel';
import { DescriptorKeyType } from '../Types';

interface IPageControlProps extends IFormProps {
	hidden: boolean;
	model: PageViewModel;
}

const PageControl: FC<IPageControlProps> = ({
	hidden,
	model,
	readOnly,
	setFieldValue,
}) => {
	const renderFormPart = (part: BaseViewModel) => {
		const isReadOnly = !part.ControlEnabling || readOnly;
		const Control = getFieldComponent(
			part.DescriptorKey as DescriptorKeyType,
		);
		return (
			<Col md={part.Width ?? 12} key={part.Path}>
				<Control
					model={part}
					readOnly={isReadOnly}
					setFieldValue={setFieldValue}
				/>
			</Col>
		);
	};

	return <Row hidden={hidden}>{model.PageElements.map(renderFormPart)}</Row>;
};

export default PageControl;
